import React, { useContext, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from '../context/TranslationContext';
import { AuthContext } from '../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import debug from '@commons-shared/debug';
import { faSliders, faPenToSquare, faComments } from '@fortawesome/free-solid-svg-icons';

// Constantes pour les icônes de navigation
const NAV_ICONS = {
  CONFIG: faSliders,
  TOOLS: faPenToSquare,
  CHATBOT: faComments
};
/**
 * Composant de navigation principale de l'application
 */
export default function MainNavigation() {
  const { t, loadPageTranslations } = useTranslation();
  const { isAuthenticated } = useContext(AuthContext);
  
  // Charger les traductions de navigation après authentification
  useEffect(() => {
    const loadTranslations = async () => {
      if (!isAuthenticated) return;
      
      try {
        // Charger les traductions de navigation
        await loadPageTranslations('NAVIGATION');
        debug.log('MainNavigation', 'Traductions NAVIGATION chargées');
      } catch (error) {
        debug.error('MainNavigation', 'Erreur lors du chargement des traductions:', error);
      }
    };
    
    loadTranslations();
  }, [isAuthenticated, loadPageTranslations]);
  
  return (
    <nav className="wa-main-navigation mb-0">
      <ul className="flex space-x-4 pb-2">
        <li>
          <NavLink 
            to="/config" 
            className={({ isActive }) => 
              `wa-nav-link ${isActive ? 'wa-nav-link--active' : ''}`
            }
            title={t('NAVIGATION', 'NAV_CONFIG', 'Configuration')}
          >
            <FontAwesomeIcon icon={NAV_ICONS.CONFIG} />
          </NavLink>
        </li>
        <li>
          <NavLink 
            to="/tools" 
            className={({ isActive }) => 
              `wa-nav-link ${isActive ? 'wa-nav-link--active' : ''}`
            }
            title={t('NAVIGATION', 'NAV_TOOLS', 'Outils d\'article')}
          >
            <FontAwesomeIcon icon={NAV_ICONS.TOOLS} />
          </NavLink>
        </li>
        <li>
          <NavLink 
            to="/chatbot" 
            className={({ isActive }) => 
              `wa-nav-link ${isActive ? 'wa-nav-link--active' : ''}`
            }
            title={t('NAVIGATION', 'NAV_CHATBOT', 'Chatbot')}
          >
            <FontAwesomeIcon icon={NAV_ICONS.CHATBOT} />
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}
